/**
 * @description
 */

import './formRadioboxResultList.scss';

import React, { Component } from 'react';
import { multipleBy, getCharIndex, getData } from '@umu/umu-util';
import { ISectionOptionResultInfo } from '@umu/umu-types';
import { components } from 'common';
const { PreImg } = components;

// import * as imageUtil from '@umu/umu-image-handle';

export interface IProps {
    resultList?: ISectionOptionResultInfo[];
}

// tslint:disable-next-line:no-empty-interface
export interface IState {}

export default class FormRdioboxResultList extends Component<IProps, IState> {
    constructor(props: IProps, state: IState) {
        super(props, state);
    }

    public render() {
        return <div className="form-option-reault-list">{this.getOptionList()}</div>;
    }

    public getItemOrder = (index: number = 0) => {
        return getCharIndex(index) + '. ';
    };

    public getOptionImg = (item: ISectionOptionResultInfo) => {
        const { resource_arr = [] } = item.extend;
        const resourceInfo = resource_arr[0];
        if (!resourceInfo) {
            return null;
        }

        const url = getData(resourceInfo, 'resource_data', 'url');
        // url = ImageUtil.appendWidth(url, 600);

        return (
            <div className="option-image">
                <div className="img">
                    <PreImg>
                        <img src={url} />
                    </PreImg>
                </div>
            </div>
        );
    };

    public getOptionList = () => {
        const { resultList } = this.props;
        if (!resultList) {
            return null;
        }

        const ret = resultList.map((item, index) => {
            return (
                <div className={`form-option-reault-item`} key={index}>
                    <div className="option-detail">
                        {this.getItemOrder(index)}
                        {item.title}
                    </div>
                    {this.getOptionImg(item)}
                    <div className="option-view">
                        <div className="option-chart">
                            <div className="option-chart-bar">
                                <div
                                    className="option-chart-value"
                                    style={{
                                        width: `${multipleBy(item.rate, 100)}%`,
                                    }}
                                ></div>
                            </div>
                        </div>
                        <div className="option-ratio">{multipleBy(item.rate, 100)}%</div>
                        <div className="option-num">{item.count}</div>
                    </div>
                </div>
            );
        });
        return ret;
    };
}
